import React from "react";
import {
  Box,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Paper,
} from "@mui/material";
const LPSkeleton = () => {
  return (
    <>
      <Box p={2} display="flex" flexDirection="column" gap={3}>
        {/* Chart Section */}
        <Paper sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom>
            <Skeleton width={350} />
          </Typography>
          <Box display="flex" gap={2} alignItems="flex-end" height={200}>
            {Array.from({ length: 40 }).map((_, i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                width={100}
                height={180}
                animation="wave"
                sx={{
                  borderRadius: 1,
                  transform: "scaleY(0)",
                  transformOrigin: "bottom",
                  animation: `growBar 0.8s ease-out forwards`,
                  "@keyframes growBar": {
                    "0%": { transform: "scaleY(0)" },
                    "100%": { transform: "scaleY(1)" },
                  },
                }}
              />
            ))}
          </Box>
        </Paper>

        {/* Keywords For Improvement Table */}
        <Paper sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom>
            <Skeleton width={250} />
          </Typography>
          <Typography variant="body2" gutterBottom>
            <Skeleton width={400} />
          </Typography>

          <Table>
            <TableHead>
              <TableRow>
                {[
                  "Keyword",
                  "Match Type",
                  "Traffic Source",
                  "Ad Group",
                  "Campaign",
                  "LP Exp.",
                  "Cost",
                  "QS",
                ].map((col) => (
                  <TableCell key={col}>
                    <Skeleton width={80} />
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.from({ length: 5 }).map((_, i) => (
                <TableRow key={i}>
                  {Array.from({ length: 8 }).map((__, j) => (
                    <TableCell key={j}>
                      <Skeleton width="80%" />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <Box
            mt={2}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Skeleton width={100} height={30} />
            <Skeleton width={150} height={30} />
          </Box>
        </Paper>

        {/* Top Keywords Table */}
        <Paper sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom>
            <Skeleton width={150} />
          </Typography>
          <Typography variant="body2" gutterBottom>
            <Skeleton width={300} />
          </Typography>

          <Table>
            <TableHead>
              <TableRow>
                {[
                  "Keyword",
                  "Match Type",
                  "Traffic Source",
                  "Ad Group",
                  "Campaign",
                  "LP Exp.",
                  "Cost",
                  "QS",
                ].map((col) => (
                  <TableCell key={col}>
                    <Skeleton width={80} />
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.from({ length: 3 }).map((_, i) => (
                <TableRow key={i}>
                  {Array.from({ length: 8 }).map((__, j) => (
                    <TableCell key={j}>
                      <Skeleton width="70%" />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </Box>
    </>
  );
};

export default LPSkeleton;
